import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalService } from '../../services/config/global/global.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class MailService {

  token: string;
  urlApi: string;
  bodyApiToken: any;
  _URL_: string;

  constructor(
    private http: HttpClient,
    private _globalService: GlobalService) {
    this._URL_ = environment._URL_;
    // Direccion url API
    this.urlApi = this._globalService.getUrlApi();
    this.token = localStorage.getItem('token');
  }

getEnvioEmail(body: any): Observable<any> {
  // Detecta si body es FormData
  const isFormData = body instanceof FormData;

  const options: Object = {
    responseType: 'text' as 'json', // si tu PHP devuelve texto
    headers: isFormData ? {} : new HttpHeaders({'Content-Type': 'application/json'})
  };

  return this.http.post<any>(this._URL_ + '/libs/envio.php', body, options);
}



}


